module.exports = __webpack_public_path__ + "assets/img/hassle-free.f8f3a742.jpg";